document.querySelectorAll(".product").forEach((product) => {
  product.querySelectorAll(".product-checkbox").forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      product.querySelectorAll(".product-checkbox").forEach((cb) => {
        if (cb !== this) cb.checked = false;
      });
    });
  });
});

$(document).ready(function () {
  $(document).on("click", ".btn_SubmitData", function () {
    var itg_spacification = "";
    $(".itg_spacification input[type=checkbox]:checked").each(function () {
      var spacificValue = $(this).val();
      itg_spacification += spacificValue + ",";
    });
    var CupSizes = ["A", "B", "C", "D", "DD", "F", "G", "H", "j"];
    var BrandName = $(".BrandOptions option:selected").attr("value");
    var BandSize = $("input[name='bandsize']:checked").val();
    var CupSize = $("input[name='cupsize']:checked").val();

    var mainBand = BandSize;
    var mainCup = CupSize;

    var limitations = "";
    $(' input[name="makeeasybra[bra][]"]:checked').each(function () {
      var spacificValue = $(this).val();
      limitations += spacificValue + ",";
    });
    var selectedSize = BandSize + "" + CupSize;
    var index = CupSizes.indexOf(CupSize);
    var CupValIndex = index;
    var CupFitVal = "";
    var CupFit = $(".three-col-radio input[name=cupsfit]:checked").val();
    if (CupFit == "Too tight, I'm bulging out!") {
      var CupFitVal = CupSizes[CupValIndex + 1];
    } else if (CupFit == "Too loose, the cups are gaping") {
      var CupFitVal = CupSizes[CupValIndex - 1];
    } else {
      var CupFitVal = CupSizes[CupValIndex];
    }
    var CupFitfinal = BandSize + "" + CupFitVal;

    var adjustedindex = CupSizes.indexOf(CupFitVal);
    var BandVal = "";

    var BandFit = $(".three-col-radio input[name=bandfit]:checked").val();
    var age = $(".old-time-radio-button-list input[name=oldbra]:checked").val();

    if (
      (BandFit == "Too loose, it rides up my back" && age == "0-6 months") ||
      (BandFit == "Too loose, it rides up my back" && age == "6-12 months")
    ) {
      var BandVal = BandSize - 2;
      var fitVal = CupSizes[adjustedindex + 1];
    } else if (
      (BandFit == "Too tight, it digs in" && age == "0-6 months") ||
      (BandFit == "Too tight, it digs in" && age == "6-12 months") ||
      (BandFit == "Too tight, it digs in" && age == "More than 1 year")
    ) {
      var BandVal = parseInt(BandSize) + parseInt(2);
      var fitVal = CupSizes[adjustedindex - 1];
    } else {
      var BandVal = BandSize;
      var fitVal = CupFitVal;
    }

    if (fitVal == undefined) {
      var fitVal = CupFitVal;
    }

    var agestepVal = BandVal + "" + fitVal;
    var finalresult = BandVal + "" + fitVal;
    var mainCupval = finalresult.replace(/\d+/g, "");
    var mainBandSize = finalresult.replace(/\D/g, "");

    $(document).on("change", ".quiz-producut-info-box input", function () {
      var sectionId = $(this).closest(".quiz-producut-info-box").attr("id");

      var colorVal = $("#" + sectionId + ' input[name="color"]:checked').val();
      var bandSize = $(
        `#${sectionId} input[name="band-size"][value^='${mainBandSize}']`
      ).prop("checked", true);
      var cupSize = $(
        `#${sectionId} input[name="cup-size"][value^='${mainCupval}']`
      ).prop("checked", true);
      var addToCartBtn = $("#" + sectionId + " .button.addToCart");
      if (!colorVal) {
        addToCartBtn.prop("disabled", true);
        return;
      } else {
        addToCartBtn.prop("disabled", false);
      }
      var $section = $("#" + sectionId);
      var selectedVariant = `${colorVal} / ${bandSize} / ${cupSize}`;
      var selectedVariantSrc = $section
        .find(`.itg_variant_group input[value="${selectedVariant}"]`)
        .attr("src");

      if (selectedVariantSrc) {
        $section.find(".Product_image img").attr("src", selectedVariantSrc);
      }
    });

    if (mainBandSize >= 32 && mainBandSize <= 46) {
      if (
        mainCupval != undefined ||
        mainCupval == "A" ||
        mainCupval == "B" ||
        mainCupval == "C" ||
        mainCupval == "D" ||
        mainCupval == "DD" ||
        mainCupval == "F"
      ) {
      }
      if (
        mainCupval == "A" ||
        mainCupval == "B" ||
        mainCupval == "C" ||
        mainCupval == "D" ||
        mainCupval == "DD" ||
        mainCupval == "F" ||
        mainCupval == "G" ||
        mainCupval == "H"
      ) {
        $(".itg_resultValue").show();
        $(".itg_resulterror").hide();
        $("#errorResult").hide();
        $("#errorResult").removeClass("activeerror");
        $("#finalsubmitbutton").show();

        // Define band size and cup size mappings
        const bandSizeMap = {
          32: "32-34",
          34: "32-34",
          36: "36-38",
          38: "36-38",
          40: "40-42",
          42: "40-42",
          44: "44-46",
          46: "44-46",
        };

        /*const cupSizeMap = {
          A: "A-B",
          B: "A-B",
          C: "C-D",
          D: "C-D",
          B: "B-D",
          D: "B-D",
          DD: "DD-F",
          F: "DD-F",
          G: "G-H",
          H: "G-H",
        }; */

        const cupSizeMap = {
          A: "A-B",
          B: "B-D",
          C: "C-D",
          D: "B-D",
          DD: "DD-F",
          F: "DD-F",
          G: "G-H",
          H: "G-H",
        };

        // Extract band and cup
        const mainBandSize = finalresult.match(/^\d+/)?.[0];
        const mainCupSize = finalresult.replace(mainBandSize, "");

        /* New Logic Product Display Code */
        // First reset all
        $(".quiz-producut-info-box")
          .removeClass("order-1 order-2 order-3")
          .hide();

        const physicalIssues = limitations.split(",").map((v) => v.trim());
        const traitPrefs = itg_spacification.split(",").map((v) => v.trim());

        const cleanedTraitPrefs = traitPrefs.filter(
          (val) => val && val !== "None"
        );
        const cleanedPhysicalIssues = physicalIssues.filter(
          (val) => val && val !== "None"
        );

        //console.log("Cup:", mainCupval);
        //console.log("Cleaned traitPrefs:", cleanedTraitPrefs);
        //console.log("Cleaned physicalIssues:", cleanedPhysicalIssues);

        const matchScores = {};
        const setMatch = (product, score) => {
          if (!(product in matchScores) || matchScores[product] > score) {
            matchScores[product] = score;
          }
        };

        // 1. Pacemaker = absolute override
        if (
          cleanedPhysicalIssues.includes("Defibrillator / pacemaker / etc.")
        ) {
          matchScores["Easy-On Mobility Bra (Seamless Cups)"] = 1;
          matchScores["Easy-On Mobility Bra (Original)"] = 2;
        } else {
          // 2. Flare ups (DD/F) → Goddess
          if (
            ["DD", "F"].includes(mainCupval) &&
            cleanedPhysicalIssues.includes("Flare ups")
          ) {
            setMatch("Goddess Lift Mobility Bra", 3);
          }

          // 3. Support + DD/F → Goddess
          if (
            ["DD", "F"].includes(mainCupval) &&
            cleanedTraitPrefs.includes("Support")
          ) {
            setMatch("Goddess Lift Mobility Bra", 4);
          }

          // 4. Support + B/C/D → Effortless
          if (
            ["B", "C", "D"].includes(mainCupval) &&
            cleanedTraitPrefs.includes("Support")
          ) {
            setMatch("The Effortless Bra", 5);
          }

          // 5. Adjustable Fit + DD/F → Goddess
          if (
            ["DD", "F"].includes(mainCupval) &&
            cleanedTraitPrefs.includes("Adjustable Fit")
          ) {
            setMatch("Goddess Lift Mobility Bra", 6);
          }

          // 6. Adjustable Fit + B/C/D → Easy-On (2 types)
          if (
            ["B", "C", "D"].includes(mainCupval) &&
            cleanedTraitPrefs.includes("Adjustable Fit")
          ) {
            setMatch("Easy-On Mobility Bra (Seamless Cups)", 7);
            setMatch("Easy-On Mobility Bra (Original)", 8);
          }

          // 7. Mastectomy or Tremors → Effortless
          if (
            cleanedPhysicalIssues.includes("Mastectomy") ||
            cleanedPhysicalIssues.includes("Tremors")
          ) {
            setMatch("The Effortless Bra", 9);
          }

          // 8. Dexterity → Effortless
          const dexterityOptions = [
            "limited hand or finger dexterity",
            "Joint pain",
          ];
          if (
            ["B", "C", "D", "DD", "F"].includes(mainCupval) &&
            cleanedPhysicalIssues.some((val) => dexterityOptions.includes(val))
          ) {
            setMatch("The Effortless Bra", 10);
          }

          // 9. Sit close together + DD/F → Goddess + Effortless
          if (
            cleanedTraitPrefs.includes("they sit close together") &&
            ["DD", "F"].includes(mainCupval)
          ) {
            setMatch("Goddess Lift Mobility Bra", 11);
            setMatch("The Effortless Bra", 12);
          }

          // 10. Limited Mobility
          const limitedMobilityOptions = [
            "Limited shoulder mobility",
            "Limited arm mobility",
            "Limb difference or amputation",
          ];
          if (
            ["DD", "F", "B", "C", "D"].includes(mainCupval) &&
            cleanedPhysicalIssues.some((val) =>
              limitedMobilityOptions.includes(val)
            )
          ) {
            if (["DD", "F"].includes(mainCupval)) {
              setMatch("Goddess Lift Mobility Bra", 13);
            } else {
              setMatch("Easy-On Mobility Bra (Seamless Cups)", 14);
              setMatch("Easy-On Mobility Bra (Original)", 15);
            }
          }

          // 11. Cup A → Effortless
          if (mainCupval === "A") {
            setMatch("The Effortless Bra", 16);
          }

          // 12. Cup G/H → Goddess
          if (["G", "H"].includes(mainCupval)) {
            setMatch("Goddess Lift Mobility Bra", 17);
          }
        }

        // Final matched list in correct order
        let orderedMatches = Object.entries(matchScores)
          .sort((a, b) => a[1] - b[1])
          .map(([product]) => product);

        // Fallback if nothing matched
        if (orderedMatches.length === 0) {
          orderedMatches = [
            "Easy-On Mobility Bra (Seamless Cups)",
            "Easy-On Mobility Bra (Original)",
            "The Effortless Bra",
            "Goddess Lift Mobility Bra",
          ];
        }

        // === DOM Ordering ===
        const $container = $(".quiz-producut-info-container");
        const $allBoxes = $(".quiz-producut-info-box");

        let matchedBoxes = [];
        let unmatchedBoxes = [];

        $allBoxes.each(function () {
          const $box = $(this);
          const title = $box.find(".product-item__title a").text().trim();
          const index = orderedMatches.indexOf(title);

          $box.removeClass((i, cls) =>
            (cls.match(/order-\d+/g) || []).join(" ")
          );

          if (index !== -1) {
            $box.addClass(`order-${index + 1}`).show();
            matchedBoxes[index] = $box;
          } else {
            unmatchedBoxes.push($box);
          }
        });

        // Add unmatched after matched
        unmatchedBoxes.forEach(($box, i) => {
          const order = matchedBoxes.length + i + 1;
          $box.addClass(`order-${order}`).show();
          matchedBoxes.push($box);
        });

        // Rebuild the container
        $container.empty();
        //matchedBoxes.forEach(($box) => $container.append($box));

        matchedBoxes.forEach(($box, idx) => {
          const isMatched = idx < orderedMatches.length;
          $container.append($box);

          // Remove old label if it exists
          $box.find(".recommend-label").remove();

          if (isMatched) {
            $box.append(
              ` <div class="recommend-label-wrapper">
                  <div class="recommend-label">Springrose Recommended</div>
                </div>`
            );
          }
        });

        /* Old working */
        const mappedBand = bandSizeMap[mainBandSize]; // e.g. "36-38"
        const mappedCup = cupSizeMap[mainCupSize]; // e.g. "G-H"

        /*$(".quiz-producut-info-box").each(function () {
          const $box = $(this);
          const hasBand =
            $box.find(`input[name='band-size'][value='${mappedBand}']`).length >
            0;
          const hasCup =
            $box.find(`input[name='cup-size'][value='${mappedCup}']`).length >
            0;
          if (hasBand && hasCup) {
            $box.show();
          } else {
            $box.hide();
          }
        });*/
        const mainMappedCupGroup = cupSizeMap[mainCupSize]; // e.g. "B-D"
        $(".quiz-producut-info-box").each(function () {
          const $box = $(this);

          const hasBand =
            $box.find(`input[name='band-size'][value='${mappedBand}']`).length >
            0;

          // Default: check for exact cup-size match
          let hasCup =
            $box.find(`input[name='cup-size'][value='${mainMappedCupGroup}']`)
              .length > 0;

          // Special rule: if mainCupSize is B, also accept cup-size="A-B"
          if (mainCupSize === "B") {
            hasCup =
              hasCup ||
              $box.find(`input[name='cup-size'][value='A-B']`).length > 0;
          }

          if (mainCupSize === "D") {
            hasCup =
              hasCup ||
              $box.find(`input[name='cup-size'][value='C-D']`).length > 0;
          }

          if (hasBand && hasCup) {
            $box.show();
          } else {
            $box.hide();
          }
        });
        localStorage.setItem("step-6", "result");
      } else {
        $(".itg_resultValue").hide();
        $(".itg_resulterror").show();
        $("#errorResult").show();
        $("#errorResult").removeClass("activeerror");
        $("#finalsubmitbutton").hide();
        localStorage.setItem("step-6", "error");
      }
    } else {
      $(".itg_resultValue").hide();
      $(".itg_resulterror").show();
      $("#errorResult").show();
      $("#errorResult").addClass("activeerror");
      $("#finalsubmitbutton").hide();
      localStorage.setItem("step-6", "error");
    }
    var details = "";
    if (itg_spacification != undefined && itg_spacification != "") {
      details +=
        '<input type="hidden" id="bra_trait_preference" name="bra_trait_preference" value="' +
        itg_spacification +
        '" />';
    } else {
      details +=
        '<input type="hidden" id="bra_trait_preference" name="bra_trait_preference" value="" />';
    }
    if (BrandName != undefined && BrandName != "") {
      details +=
        '<input type="hidden" id="go_to_brand" name="go_to_brand" value="' +
        BrandName +
        '" />';
    } else {
      details +=
        '<input type="hidden" id="go_to_brand" name="go_to_brand" value="" />';
    }
    if (
      mainBand != undefined &&
      mainBand != "" &&
      mainCup != undefined &&
      mainCup != ""
    ) {
      details +=
        '<input type="hidden" id="previous_best_fitting_bra" name="previous_best_fitting_bra" value="' +
        mainBand +
        "" +
        mainCup +
        '" />';
    } else {
      details +=
        '<input type="hidden" id="previous_best_fitting_bra" name="previous_best_fitting_bra" value="Wireless"/>';
    }
    if (CupFit != undefined && CupFit != "") {
      details +=
        '<input type="hidden" id="previous_bra_cup_fit" name="previous_bra_cup_fit" value="' +
        CupFit +
        '" />';
    } else {
      details +=
        '<input type="hidden" id="previous_bra_cup_fit" name="previous_bra_cup_fit" value="" />';
    }
    if (BandFit != undefined && BandFit != "") {
      details +=
        ' <input type="hidden" id="previous_bra_band_fit" name="previous_bra_band_fit" value="' +
        BandFit +
        '" />';
    } else {
      details +=
        ' <input type="hidden" id="previous_bra_band_fit" name="previous_bra_band_fit" value="" />';
    }

    if (age != undefined && age != "") {
      details +=
        '<input type="hidden" id="previous_bra_age" name="previous_bra_age" value="' +
        age +
        '" />';
    } else {
      details +=
        '<input type="hidden" id="previous_bra_age" name="previous_bra_age" value="" />';
    }

    details +=
      '<input type="hidden" id="physical_limitations" name="physical_limitations" value="' +
      limitations +
      '" />';
    $(".itg_result").html(details);
    $(".result_value.itg_result").html(finalresult);
    $('#resultinput[name="final_result"]').attr("value", finalresult);
    localStorage.setItem("step-result_6", finalresult);
    localStorage.setItem("step-details_6", details);
  });
  document.querySelectorAll(".quiz-producut-info-box").forEach((product) => {
    product.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        let group = this.getAttribute("data-group");
        product
          .querySelectorAll(`input[data-group="${group}"]`)
          .forEach((cb) => {
            if (cb !== this) cb.checked = false;
          });
      });
    });
  });

  $(document).on("click", ".button.addToCart", function (e) {
    e.preventDefault();
    var $section = $(this).closest(".quiz-producut-info-box");
    var sectionId = $section.attr("id");
    var colorVal = $section.find('input[name="color"]:checked').val();
    var bandSize = $section
      .find('input[name="band-size"]:checked')
      .map(function () {
        return $(this).val();
      })
      .get()
      .join(", ");

    var cupSize = $section
      .find('input[name="cup-size"]:checked')
      .map(function () {
        return $(this).val();
      })
      .get()
      .join(", ");
    //alert("Color: " + colorVal);
   // alert("Band Size: " + bandSize);
    //alert("Cup Size: " + cupSize);

    console.log("Color:", colorVal);
    console.log("Band Size:", bandSize);
    console.log("Cup Size:", cupSize);
    console.log("variant ID:", selectedVariantId);

    var selectedVariant = `${colorVal} / ${bandSize} / ${cupSize}`;
    var selectedVariantId = $(
      `#${sectionId} .itg_variant_group input[value="${selectedVariant}"]`
    ).attr("id");

    if (!colorVal || !bandSize || !cupSize || !selectedVariantId) {
      alert("Please choose a color for the product.");
      $(this).prop("disabled", true);
      return;
    }
    $(this).prop("disabled", false);
    const discountCode = "HXE81NHAGD9A";
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: selectedVariantId,
      },
      dataType: "json",
      success: function () {
        localStorage.setItem(
          "image",
          $section.find(".Product_image img").attr("src")
        );
        window.history.pushState("", "", window.location.pathname + "?step7");
        window.location.href = `/checkout?discount=${encodeURIComponent(
          discountCode
        )}`;
      },
      error: function (err) {
        alert(
          "There was an error adding the product to the cart. Please try again."
        );
         if (typeof event !== "undefined") event.preventDefault();
          return false;
      },
    });
  });
});
/* Add New Form Fillup Data */
$(document).ready(function () {
  const formSelector = "form"; // your quiz form selector
  const storageKey = "braQuizFormData";

  // === Save form data ===
  function saveFormData() {
    const data = {};
    $(`${formSelector} :input`).each(function () {
      const name = $(this).attr("name");
      const type = $(this).attr("type");
      if (!name) return;

      if (type === "checkbox" || type === "radio") {
        data[name] = data[name] || [];
        if ($(this).is(":checked")) data[name].push($(this).val());
      } else {
        data[name] = $(this).val();
      }
    });
    sessionStorage.setItem(storageKey, JSON.stringify(data)); // ✅ changed
  }

  // === Restore form data ===
  function restoreFormData() {
    const saved = sessionStorage.getItem(storageKey); // ✅ changed
    if (!saved) return;
    const data = JSON.parse(saved);

    Object.keys(data).forEach((name) => {
      const value = data[name];
      const $inputs = $(`${formSelector} [name="${name}"]`);

      $inputs.each(function () {
        const type = $(this).attr("type");
        const tag = this.tagName.toLowerCase();

        if (type === "checkbox" || type === "radio") {
          $(this).prop(
            "checked",
            Array.isArray(value) && value.includes($(this).val())
          );
        } else if (tag === "select") {
          const $select = $(this);

          $select.val(value);
          if ($select.val() !== value && value !== "") {
            $select.find(`option[value="${value}"]`).prop("selected", true);
          }

          setTimeout(() => {
            $select.trigger("change").trigger("input");
          }, 100);
        } else {
          $(this).val(value);
        }
      });
    });
  }

  // === Run restore after page load ===
  setTimeout(() => {
    restoreFormData();
  }, 300);

  // === Auto-save on input changes ===
  $(document).on("change keyup input", `${formSelector} :input`, function () {
    saveFormData();
  });

  // === Clear storage on final form submit ===
  $(document).on("submit", formSelector, function () {
    sessionStorage.removeItem(storageKey); // ✅ changed
  });

  // === Make .FindSizeQuiz visible and clickable ===
  $(".FindSizeQuiz").css({
    opacity: "1",
    "pointer-events": "auto",
  });
});



// === Handle quiz step navigation with hash support ===
(function() {
  const redirectURL = "https://www.springrose.co/pages/adaptive-wireless-bras-front-closure-bras-find-your-size-bra-size-quiz";

  // Push a dummy state so back button triggers popstate
  window.history.pushState({ page: 1 }, "", "");

  window.addEventListener("popstate", function (event) {
    if (event.state) {
      // User clicked browser back button → redirect
      window.location.href = redirectURL;
    } else {
      // Some Firefox versions may not include state object, handle fallback
      window.location.href = redirectURL;
    }
  });
})();